<template>
  <div class="lnner">
    <div
      v-if="IsIframe"
      id="imiframe_iconBox"
      ref="imiframe_iconBox"
      :class="{ animate, enter, unfold }"
      @mouseenter="mouseenterAnimate"
      @mouseleave="unfold = animate = enter = false"
      @click="unfold = animate = enter = false"
    >
      <div class="imiframe_icon_imgUl">
        <div v-if="imunreadcount" class="messageNum red">{{ imunreadcount }}</div>
        <a
          href="javascript:;"
          ref="aNoparameter"
          target="view_window"
          class="imUrl"
          @click.stop.prevent="imUrlCb"
        >
          <span class="name">Contact TM\CS</span>
          <img class="icon" :src="msgImgs" />
        </a>
        <div class="rightMsg">
          <div class="ulBox">
            <div class="imiframe_content">
              <ul class="imiframe_icon_titleUl">
                <li
                  v-for="item in imMessageArr"
                  :key="item.account + 'imiframe'"
                  :data-scene="item.scene"
                  :data-account="item.account"
                >
                  <a
                    :data-href="'?account=' + item.account + '&scene=' + item.scene"
                    ref="aHasParameter"
                    target="view_window"
                    @click.stop.prevent="readMsg($event, item.conversationID, item.account)"
                  >
                    <b>{{ nickReplace(item.nick) }}</b>
                    <p v-html="item.text"></p>
                  </a>
                  <div class="messageNum green">
                    {{ item.unread > 99 ? '99+' : item.unread }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TIM from 'tim-js-sdk'
import { langText, appUI } from '@/utils/imTools.js'
import { getIframeApi, getLoginInfoApi, imUrlApi } from '@/api/imiframe.js'
import msgImg from '@/assets/img/common/Group_message1.png'
import defaultHead from '@/assets/img/common/default-icon1.png'
import { useImBusStore } from '@/stores/imBus'
import { storeToRefs } from 'pinia'

export default {
  name: 'ImIframe',
  setup() {
    const imBus = useImBusStore()
    const { imiframeApi, logined } = storeToRefs(imBus)
    return {
      imBus,
      imiframeApi,
      logined
    }
  },
  data() {
    return {
      timjs: null,
      identifier: null,
      sdkAppID: null,
      userSig: null,
      getSessoins: null,
      robotServiceConversationID: 'C2C100',
      takeBack: null,
      imMessageObj: null,
      imMessageArr: [],
      takeOutJudge: false,
      imunreadcount: null,
      animate: false,
      enter: false,
      unfold: false,
      oldImMessageObj: undefined,
      IsIframe: false,
      msgImgs: msgImg,
      defaultHead
    }
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    if (this.takeBack) clearTimeout(this.takeBack)
    if (this.timjs) {
      this.timjs.off(TIM.EVENT.SDK_READY, this.onReadyStateUpdate)
      this.timjs.off(TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate)
      this.timjs.off(TIM.EVENT.MESSAGE_RECEIVED, this.doMsg)
    }
  },
  methods: {
    init() {
      getIframeApi()
        .then((res) => {
          if (!res.data.ErrorCode && res.data.Msg) {
            this.imBus.setImiframeApi(res.data.Msg)
            this.IsIframe = true
          } else {
            this.IsIframe = false
          }
        })
        .catch((error) => {
          this.IsIframe = false
          console.log(error)
        })
      getLoginInfoApi().then((data) => {
        data = data.data.Body
        if (data.code == 0) {
          this.identifier = data.identifier
          this.sdkAppID = data.sdkAppID
          this.userSig = data.userSig
          appUI.currentType = data.UserType
          appUI.authTypeJson = data.authTypeJson ? JSON.parse(data.authTypeJson) : []
          appUI.authTypeJson.push({ UserType: 3, UserTypeName: 'Teacher' })
          appUI.authTypeJson.push({ UserType: 3, UserTypeName: 'Tutor' })
          appUI.authTypeJson.push({ UserType: 99, UserTypeName: 'myTeacher' })
          const options = {
            SDKAppID: data.sdkAppID
          }
          this.timjs = TIM.create(options)
          this.imBus.setTimjs(this.timjs)
          this.timjs.setLogLevel(1)
          this.timjs.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this)
          this.timjs.on(TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
          this.timjs.on(TIM.EVENT.MESSAGE_RECEIVED, this.doMsg, this)
          this.timjsLogin()
        }
      })
    },
    imUrlCb() {
      imUrlApi().then((res) => {
        this.imBus.setImiframeApi(res.data.imdomain)
        this.imBus.setLogined()
        window.open(res.data.tmpUrl, 'view_window')
      })
    },
    timjsLogin() {
      this.timjs
        .login({ userID: this.identifier, userSig: this.userSig })
        .then(() => {})
        .catch((err) => {
          console.log('-----err-----', err)
        })
    },
    onReadyStateUpdate(e) {
      const isSDKReady = e.name === TIM.EVENT.SDK_READY
      if (isSDKReady) {
        this.timjsGetSessions()
      }
    },
    timjsGetSessions() {
      this.timjs.getConversationList().then((res) => {
        const ids = []
        const users = []
        const arr = res.data.conversationList
        let unreadAll = 0
        const imMessageCount = {}
        this.getSessoins = true
        if (arr && arr.length > 0) {
          for (let i = 0, len = arr.length; i < len; i++) {
            const item = arr[i]
            const type = item.type
            let scene
            let sessionId
            let sessionNick = ''
            let sessionImage = ''
            let name
            let userType
            let MsgShow
            unreadAll += item.unreadCount
            if (item.conversationID == this.robotServiceConversationID) {
              continue
            }
            if (type == TIM.TYPES.CONV_C2C) {
              ids.push(item.toAccount)
              scene = 'p2p'
              sessionId = item.toAccount
              sessionNick = item.userProfile.nick || sessionId
              const nickObj = appUI.makeNick(item.userProfile.nick)
              name = nickObj.nick
              userType = nickObj.index
              sessionImage = item.userProfile.avatar || this.defaultHead
              if (sessionId == '@TIM#SYSTEM') {
                console.log('------------好友系统消息', item)
                continue
              }
              users.push({
                state: null,
                account: sessionId,
                nick: sessionNick,
                name,
                userType,
                userId: undefined,
                avatar: sessionImage
              })
            } else if (type == TIM.TYPES.CONV_GROUP) {
              scene = 'team'
              sessionId = item.toAccount
              sessionNick = item.groupProfile.name || sessionId
              const senderId = item.lastMessage.fromAccount
              if (!senderId) {
                continue
              }
              if (senderId == '@TIM#SYSTEM') {
                continue
              }
            } else if (type == TIM.TYPES.CONV_SYSTEM) {
              sessionNick = 'system Message'
              sessionId = item.toAccount
            }
            if (!sessionId) {
              continue
            }
            if (sessionId == '@TLS#NOT_FOUND') {
              continue
            }
            MsgShow = appUI.convertMsgtoHtmlType(
              item.conversationID,
              item.lastMessage.type,
              item.lastMessage.payload,
              true
            )
            if (item.unreadCount && type != TIM.TYPES.CONV_SYSTEM) {
              imMessageCount[sessionId] = {
                conversationID: item.conversationID,
                unread: item.unreadCount,
                time: item.lastMessage.lastTime,
                nick: appUI.makeNick(sessionNick).nick,
                text: appUI.formatText2Node(MsgShow),
                account: sessionId,
                scene
              }
            }
          }
          this.imunreadcount = unreadAll
          this.imMessageObj = imMessageCount
          this.resetImMessage()
          this.GetImUnRead()
        }
      })
    },
    resetImMessage() {
      const imMessageArr = []
      const arr = Object.values(this.imMessageObj).sort((a, b) => b.time - a.time)
      for (let i = 0, len = arr.length; i < len; i++) {
        imMessageArr.push(arr[i])
      }
      this.imMessageArr = imMessageArr
    },
    doMsg(e) {
      if (!e.name || !this.getSessoins) {
        return
      }
      const newMsgList = e.data
      for (let j = 0; j < newMsgList.length; j++) {
        const newMsg = newMsgList[j]
        const userId = newMsg.from
        let isObj
        let RoomId
        let inviteID
        if (!newMsg.payload) continue
        isObj = appUI.typeObject(newMsg.payload.data)
        if (isObj) {
          const mediaObj = JSON.parse(isObj.data)
          RoomId = mediaObj.room_id
          inviteID = isObj.inviteID
        } else {
          RoomId = newMsg.payload.extension
        }
        if (newMsg.from != this.identifier && newMsg.type == TIM.TYPES.MSG_CUSTOM) {
          if (newMsg.payload.description == 'audio-join') {
            this.getUserInfo(newMsg.from, ({ name, avatar }) => {
              this.showMessageNotification(name + langText('audioInvite'), newMsg.from)
              this.imBus.setImLinkShowState({
                imLinkShow: true,
                imLinkName: name,
                imLinkHead: avatar,
                imLinkAccount: newMsg.from,
                imLinkScene: 'p2p',
                RoomId,
                userId,
                inviteID,
                mediaType: 1
              })
            })
          } else if (newMsg.payload.description == 'video-join') {
            this.getUserInfo(newMsg.from, ({ name, avatar }) => {
              this.showMessageNotification(name + langText('videoInvite'), newMsg.from)
              this.imBus.setImLinkShowState({
                imLinkShow: true,
                imLinkName: name,
                imLinkHead: avatar,
                imLinkAccount: newMsg.from,
                imLinkScene: 'p2p',
                RoomId,
                userId,
                inviteID,
                mediaType: 2
              })
            })
          } else if (
            newMsg.payload.description == 'audio-leave' ||
            newMsg.payload.description == 'video-leave'
          ) {
            this.imBus.setImLinkShowState({ imLinkShow: false })
          }
        }
      }
      this.timjsGetSessions()
    },
    readMsg(event, conversationID, sessionId) {
      if (this.logined) {
        const url = event.currentTarget.dataset.href
        window.open(this.imiframeApi + url, 'view_window')
        delete this.imMessageObj[sessionId]
        this.timjs.setMessageRead({ conversationID }).then(() => {
          this.timjsGetSessions()
          this.resetImMessage()
        })
      } else {
        this.imUrlCb()
      }
    },
    nickReplace(nick) {
      if (nick) {
        return nick.replace('&nbsp;', ' ')
      }
    },
    mouseenterAnimate() {
      if (this.imunreadcount) {
        this.unfold = false
        this.animate = this.enter = true
      } else {
        this.unfold = true
      }
    },
    GetImUnRead() {
      this.takeOutJudge = false
      if (Object.values(this.imMessageObj).length > 0) {
        for (const key in this.imMessageObj) {
          const ele = this.imMessageObj[key]
          if (
            this.oldImMessageObj &&
            !this.takeOutJudge &&
            ele.unread < 6 &&
            ele.unread !== ((this.oldImMessageObj[key] && this.oldImMessageObj[key].unread) || 0)
          ) {
            this.takeOutJudge = true
          }
        }
        if (!this.oldImMessageObj) {
          this.takeOutJudge = true
        }
        if (this.takeOutJudge) {
          this.animate = true
        }
        if (this.takeBack) {
          clearTimeout(this.takeBack)
        }
        this.takeBack = setTimeout(() => {
          if (!(this.$refs.imiframe_iconBox?.className?.indexOf('enter') > -1)) {
            this.animate = false
          }
        }, 5000)
      } else {
        this.imMessageObj = {}
        this.imunreadcount = 0
      }
      this.oldImMessageObj = Object.create(this.imMessageObj)
    },
    showMessageNotification(message, userId) {
      if (window.Notification && window.Notification.requestPermission) {
        window.Notification.requestPermission((result) => {
          if (result != 'granted') {
            console.log("-----We weren't granted permission.-----")
          }
          let msg = message
          if (msg.length > 30) {
            msg = msg.substr(0, 30) + '...'
          }
          new Notification(`IM ${langText('msgReminding')}`, {
            tag: `${userId}`,
            renotify: true,
            silent: true,
            requireInteraction: true,
            icon: '/imAdmin/favicon.ico',
            body: msg
          })
        })
      }
    },
    getUserInfo(accounts, cbOk) {
      let options
      if (accounts instanceof Array) {
        options = { userIDList: accounts }
      } else {
        options = { userIDList: [String(accounts)] }
      }
      this.timjs.getUserProfile(options).then((res) => {
        const arr = res.data
        const userList = []
        if (arr.length > 0) {
          for (let i = 0, len = arr.length; i < len; i++) {
            const ele = arr[i]
            const nickObj = appUI.makeNick(ele.nick)
            userList.push({ name: nickObj.nick, avatar: ele.avatar })
          }
        }
        if (cbOk) cbOk(userList[0])
      })
    }
  }
}
</script>

<style scoped>
#imiframe_iconBox {
  z-index: 99;
  position: relative;
  height: 32px;
  margin-bottom: 10px;
}

#imiframe_iconBox.animate .ulBox {
  width: 160px;
  height: auto;
  overflow: hidden;
}

#imiframe_iconBox.animate .imiframe_content {
  overflow-y: auto;
  overflow-x: hidden;
}

#imiframe_iconBox.animate .imiframe_icon_titleUl .messageNum {
  opacity: 1;
}

#imiframe_iconBox .messageNum {
  min-width: 18px;
  height: 18px;
  position: absolute;
  top: 8px;
  font-size: 14px;
  border-radius: 30px !important;
  color: #fff;
  text-align: center;
  line-height: 18px;
}

.imiframe_icon_titleUl .messageNum {
  opacity: 0;
}

#imiframe_iconBox .messageNum.green {
  background: #16b966;
  left: calc(100% - 24px);
}

#imiframe_iconBox .messageNum.red {
  background: #ff3838;
  top: -6px;
  right: -6px;
  z-index: 2;
}

#imiframe_iconBox ul,
#imiframe_iconBox li {
  list-style: none;
  padding: 0;
  margin: 0;
}

#imiframe_iconBox .imiframe_icon_imgUl {
  width: 37px;
  height: 32px;
  position: absolute;
  border-radius: 0 30px 30px 0 !important;
  border: 1px solid #1dc15a;
  background: #e5fef3;
  z-index: 1;
  transition: all 0.5s;
}

#imiframe_iconBox .imiframe_icon_imgUl .imUrl {
  width: 100%;
  height: 100%;
  font-size: 0;
  display: flex;
  flex-flow: row nowrap;
  text-decoration: none;
  position: relative;
}

#imiframe_iconBox .imiframe_icon_imgUl .name {
  flex: 1;
  width: 0;
  opacity: 0;
  font-size: 12px;
  line-height: 32px;
  white-space: nowrap;
  color: #32397a;
  transition: all 0.3s;
  overflow: hidden;
  font-weight: 700;
}

#imiframe_iconBox.unfold .imiframe_icon_imgUl {
  width: 160px;
}

#imiframe_iconBox.unfold .imiframe_icon_imgUl .name {
  opacity: 1;
  padding-left: 10px;
}

#imiframe_iconBox .imiframe_icon_imgUl img {
  width: 26px;
  height: 26px;
  padding: 2px;
  display: block;
  box-sizing: content-box;
  cursor: pointer;
}

#imiframe_iconBox .imiframe_icon_imgUl .imUrl img.icon {
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 2px !important;
  margin-top: 7px !important;
  margin-right: 8px !important;
}

.rightMsg {
  float: right;
  position: relative;
}

.ulBox {
  position: absolute;
  left: 1px;
  bottom: 0px;
  overflow: hidden;
  width: 0;
  height: 0;
  transition: all 1s;
}

.imiframe_content {
  height: auto;
  overflow: hidden;
  max-height: 150px;
}

::-webkit-scrollbar {
  width: 10px;
  cursor: pointer;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #8899a7;
  border-radius: 4px;
}

.imiframe_icon_titleUl {
  padding: 0;
  font-size: 0;
}

.imiframe_icon_titleUl li {
  width: 100%;
  height: 50px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding: 0 16px !important;
  border: 1px solid #91dca5;
  overflow: hidden;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.65);
}

.imiframe_icon_titleUl li a {
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  text-decoration: none;
  outline: none;
}

.imiframe_icon_titleUl li:hover {
  background: #fff;
}

.imiframe_icon_titleUl li b {
  font-size: 16px;
  color: rgba(72, 81, 90, 1);
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  display: block;
  line-height: 1.4;
  margin-top: 4px;
}

.imiframe_icon_titleUl li p {
  font-size: 14px;
  color: rgba(72, 81, 90, 0.6);
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  display: block;
  line-height: 1.2;
  margin: 0;
}
</style>
